<template>
    <div>
        <usage-chart
            v-if="chartConfig && displayRows"
            :rows="displayRows"
            :chartType="chartType"
            :columnSettings="displayColumnSettings"
            :chartOptions="chartOptions"
        />
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import UsageChart from './UsageChart.vue';

    export default {
        components: { 'usage-chart': UsageChart },
        props: {
            organizationId: { type: Number, required: true },
            chartConfig: { type: Object, required: true },
            themeProfileId: { type: Number, required: false }
        },

        data: function () {
            return {
                usageStatistics: null,
                chartData: null
            };
        },

        computed: {
            filter() {
                return this.chartConfig.filter;
            },

            chartType() {
                return this.chartConfig.chartType;
            },

            chartSettings() {
                return this.chartConfig.settings;
            },

            chartOptions() {
                return this.chartSettings.options;
            },

            resultsTable() {
                if (!this.usageStatistics) {
                    return null;
                }
                return this.usageStatistics?.tables?.[0];
            },

            resultsColumns() {
                if (!this.resultsTable) {
                    return null;
                }
                return this.resultsTable.columns;
            },

            resultsRows() {
                if (!this.resultsColumns) {
                    return null;
                }
                const resultsTable = this.resultsTable;
                if (this.themeProfileId) {
                    const customDataColumnIndex =
                        this.findColumnIndex('customDimensions');
                    return resultsTable.rows.filter((row) => {
                        const profiles = row[customDataColumnIndex]?.profiles;
                        return profiles?.includes(this.themeProfileId);
                    });
                }
                return resultsTable.rows;
            },

            displayRows() {
                if (!this.resultsRows) {
                    return null;
                }
                return this.resultsRows.map((row) => {
                    return this.chartSettings.rows.map((rowSetting) => {
                        const rowType = this.findColumnType(rowSetting.columnName);
                        const columnData =
                            row[this.findColumnIndex(rowSetting.columnName)];
                        if (rowType === 'datetime') {
                            return new Date(columnData);
                        }
                        return columnData;
                    });
                });
            },

            displayColumnSettings() {
                return this.chartSettings.rows.map((rowSetting) => ({
                    name: rowSetting.dataName,
                    type: this.findColumnType(rowSetting.columnName)
                }));
            }
        },

        methods: {
            ...mapActions(['getUsageChartData']),

            async init() {
                this.usageStatistics =
                    this.chartData || (await this.getChartData());
            },

            async getChartData() {
                const organizationId = this.organizationId.toString();
                return this.getUsageChartData({
                    filter: this.filter,
                    organizationId
                });
            },

            findColumnIndex(columnName) {
                return this.resultsColumns.findIndex(
                    ({ name }) => name === columnName
                );
            },

            findColumnType(columnName) {
                let typeFromApi =
                    this.resultsColumns[this.findColumnIndex(columnName)].type;
                if (typeFromApi === 'int' || typeFromApi === 'long') {
                    typeFromApi = 'number';
                }
                return typeFromApi;
            }
        },

        watch: {
            chartData: {
                handler: function (newVal) {
                    this.usageStatistics = newVal;
                },
                immediate: true
            },

            filter: {
                handler: function () {
                    this.init();
                },
                immediate: true
            }
        }
    };
</script>
